import { Card, CardContent } from '@/components/ui/card';

export const KPICard = ({ label, value, icon: Icon, subtitle, testId, className = '', compact }) => (
  <Card
    className={`kpi-card rounded-xl border bg-white transition-shadow duration-200 ${className}`}
    data-testid={testId}
  >
    <CardContent className="p-4 sm:p-5">
      <div className="flex items-start justify-between mb-2 sm:mb-3">
        <span className="text-[9px] sm:text-[10px] font-semibold text-slate-400 uppercase tracking-widest leading-tight pr-2">{label}</span>
        {Icon && (
          <div className="h-7 w-7 sm:h-8 sm:w-8 rounded-lg bg-[rgba(240,90,40,0.06)] flex items-center justify-center shrink-0">
            <Icon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#F05A28]" strokeWidth={1.8} />
          </div>
        )}
      </div>
      <p
        className="text-[15px] sm:text-[17px] lg:text-[20px] font-semibold tracking-tight text-slate-900 tabular-nums leading-none truncate"
        style={{ fontFamily: 'Space Grotesk, sans-serif' }}
        title={typeof value === 'string' ? value : undefined}
      >
        {value}
      </p>
      {subtitle && (
        <p className="text-[10px] sm:text-[11px] text-slate-400 mt-1.5 sm:mt-2 truncate">{subtitle}</p>
      )}
    </CardContent>
  </Card>
);
